var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.team)?_c('cld-image',{staticClass:"d-inline-flex",style:({maxWidth: _vm.height + 'px'}),attrs:{"publicId":'/sandkastenliga/realteams/' + _vm.teamId,"width":_vm.height,"height":_vm.height,"crop":"fill","dpr":"auto","responsive":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }